import { SEMANTIC_CLASSES, SEMANTIC_TAG_COLOR, SemanticStatus } from "./statusColors";

// Canonical mapping of job status -> semantic bucket. Change color meaning
// here once and every page (Dashboard, Jobs, Clients, RecentJobsTable) picks
// it up — do not redeclare a parallel status→color map in a page file.
export const JOB_STATUS_SEMANTIC: Record<string, SemanticStatus> = {
  draft: "neutral",
  scheduled: "warning",
  in_progress: "info",
  completed: "success",
  cancelled: "danger",
  on_hold: "warning",
};

const JOB_STATUS_LABEL: Record<string, string> = {
  draft: "Draft",
  scheduled: "Scheduled",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
  on_hold: "On Hold",
};

// Tailwind bg/text classes per job status — used by badge-style pills.
export const JOB_STATUS_CFG: Record<string, { bg: string; text: string; label: string }> =
  Object.fromEntries(
    Object.entries(JOB_STATUS_SEMANTIC).map(([status, semantic]) => [
      status,
      { ...SEMANTIC_CLASSES[semantic], label: JOB_STATUS_LABEL[status] ?? status },
    ]),
  );

// AntD <Tag color="..."> keyword per job status — used wherever an AntD Tag
// (rather than a Tailwind pill) renders the status, e.g. the Dashboard.
export const JOB_STATUS_TAG_CFG: Record<string, { cls: string; label: string }> =
  Object.fromEntries(
    Object.entries(JOB_STATUS_SEMANTIC).map(([status, semantic]) => [
      status,
      { cls: SEMANTIC_TAG_COLOR[semantic], label: JOB_STATUS_LABEL[status] ?? status },
    ]),
  );
